import type { FocusEvent } from 'react';

import { deferredSelect, useSelectOnFocusEnabledWithLegacyFallback } from '@makemydeal/dr-shared-components/select-on-focus';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

export const useSellRateInputFocus = () => {
    const isAutoSelectEnabled = useSelectOnFocusEnabledWithLegacyFallback(
        featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap
    );

    return (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (isAutoSelectEnabled) deferredSelect(e.currentTarget);
    };
};
